import { Children } from 'react';
import findSelectedAndHighlightedChildren from './findSelectedAndHighlightedChildren';
import getValue from './getValue';

export default function autoSelectChildren(
  someChildren,
  selectListValue,
  selectListHighlightValue,
  onClick,
  onMouseOver
) {
  const childrenArray = Children.toArray(someChildren);
  const {
    selectedChildren,
    highlightedChildren,
  } = findSelectedAndHighlightedChildren(
    childrenArray,
    selectListValue,
    selectListHighlightValue
  );

  const children = childrenArray.map(child => {
    const selected = selectedChildren.indexOf(child) !== -1;
    const highlight = highlightedChildren.indexOf(child) !== -1;

    return {
      ...child,
      props: {
        ...child.props,
        selectListProps: {
          value: getValue(child),
          onClick,
          onMouseOver,
          highlight,
          selected,
        },
      },
    };
  });

  return children;
}
